import React from 'react';
import {Form, Formik, FormikProps, FormikValues} from 'formik';
import {useTranslation} from 'react-i18next';
import LightGreenButton from '../Buttons/LightGreenButton';
import GreenButton from '../Buttons/GreenButton';

type FilterWrapperProps<T extends FormikValues> = {
	active: boolean;
	initialValues: T;
	onSubmit: (values: T) => void;
	onReset: () => void;
	validationSchema?: any;
	enableReinitialize?: boolean;
	children: (formikProps: FormikProps<T>) => React.ReactNode;
	submitButtonText?: string;
	resetButtonText?: string;
	className?: string;
};

/**
 * Универсальный компонент обёртки для фильтров
 * Предоставляет единую структуру с Formik и стандартными кнопками
 * 
 * @example
 * <FilterWrapper
 *   active={isActive}
 *   initialValues={{month: '', status: ''}}
 *   onSubmit={handleSubmit}
 *   onReset={handleReset}
 * >
 *   {({values, setFieldValue}) => (
 *     <>
 *       <FilterBySixMonths setFieldValue={setFieldValue} />
 *       <FilterByStatus value={values.status} fieldName="status" />
 *     </>
 *   )}
 * </FilterWrapper>
 */
function FilterWrapper<T extends FormikValues>({
	active,
	initialValues,
	onSubmit,
	onReset,
	validationSchema,
	enableReinitialize = false,
	children,
	submitButtonText,
	resetButtonText,
	className = '',
}: FilterWrapperProps<T>) {
	const {t} = useTranslation();

	return (
		<div
			className={`filter-team__filter-item item-filter ${!active ? '' : 'active'} ${className}`}
		>
			<div className="item-filter__wrapper">
				<Formik
					initialValues={initialValues}
					onSubmit={onSubmit}
					validationSchema={validationSchema}
					enableReinitialize={enableReinitialize}
				>
					{(formikProps) => (
						<Form className="item-filter__form form-filter">
							{children(formikProps)}
							<div className="item-filter__buttons">
								<LightGreenButton
									text={submitButtonText || t('застосувати')}
									type="submit"
								/>
								<GreenButton
									text={resetButtonText || t('скасувати фільтр')}
									type="button"
									onClick={onReset}
								/>
							</div>
						</Form>
					)}
				</Formik>
			</div>
		</div>
	);
}

export default FilterWrapper;

